/**
* axios API
*/
import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import Alert from 'vux/src/components/alert/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'


Vue.prototype.$axios = axios  
Vue.prototype.qs = qs     
Vue.prototype.api_token = 'king'



Vue.prototype.$is_test = false;

Vue.prototype.host_url = 'http://api.gzyawen.com/';
Vue.prototype.server_api_url = Vue.prototype.host_url+'member/api/index?'
Vue.prototype.$login_member_key = 'login_member_data_new-v7';
Vue.prototype.$access_token_key = 'login_access_token_value-v7';


/*
*获取资讯列表
*/


Vue.prototype.get_wx_code = function(){
let api_url = this.server_api_url+'service=wxlogin_get_code_url';
this.$axios({
method:'post',
url:api_url,
data:{//这里是发送给后台的数据
token:'king'
}
}).then((response) =>{          //这里使用了ES6的语法
console.log(response.data.data.url)       
if(response.data.data.url){
window.location.href = response.data.data.url;
}
}).catch((response) =>{
console.log(response)       
})
}

Vue.prototype.save_wx_code = function(code,state){
let api_url = this.server_api_url+'service=wxlogin_save_member'
this.$axios({
method:'post',
url:api_url,
data:this.qs.stringify({//这里是发送给后台的数据
code:code,
state:state
})
}).then((response) =>{          //这里使用了ES6的语法
console.log('save_wx_code response.data');
console.log(response.data);     
let data_arr = response.data;
if(data_arr.status == '1'){
this.set_login_session_data(data_arr.data);
this.set_access_token(data_arr.access_token);


if(!data_arr.data.YZICode){


this.$router.push({path: '/Login'});
}else{

this.$router.push({path: '/MemberCenter'});
}
}else{

this.$router.push({path: '/'});
}
}).catch((response) =>{
console.log(response)       
})
}

Vue.prototype.get_login_session_data = function(){

if(this.$is_test){

let login_data = {};
login_data.account = '15***189';
login_data.member_phone = '15123456789';
login_data.openid = 'oq1_11YT4HtwIHCfLucMMnr6wQXI';
login_data.member_id = 1;
login_data.real_name = '杨穗红、叶伟篪';
login_data.house_nums = 1;
login_data.house_addr = '骏文雅苑-C座-2701';
login_data.house_id = 162;
login_data.house_NO = 2701;
login_data.YZICode = 'YZ00005';
login_data.YZICode_cur = 'YZ00005';

login_data.disabled = '0';
return login_data;
}
let login_data = {};
if(!!localStorage.getItem(this.$login_member_key)){
login_data = JSON.parse(localStorage.getItem(this.$login_member_key));
}
/*if(!!localStorage.getItem(this.$login_member_key)){
login_data = JSON.parse(localStorage.getItem(this.$login_member_key));
}*/


return login_data;
}

Vue.prototype.set_login_session_data = function(login_data){
localStorage.setItem(this.$login_member_key,JSON.stringify(login_data));



}
Vue.prototype.clear_login_session_data = function(login_data){
localStorage.removeItem(this.$login_member_key);
localStorage.removeItem(this.$access_token_key);



}

Vue.prototype.set_access_token = function(jwt_login_value){
localStorage.setItem(this.$access_token_key,jwt_login_value);



}

Vue.prototype.get_access_token = function(){

let jwt_str ='';
if(this.$is_test){

jwt_str = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJTSEEyNTYifQ.eyJpc3MiOiJ5YXdlbl93dXllIiwiaWF0IjoxNTQ1NDAyMzI5LCJleHAiOjE1NDU0MDI1MDksInVpZCI6Im9xMV8xMVlUNEh0d0lIQ2ZMdWNNTW5yNndRWEkjIzEifQ.bc0414f44ce294778e4c58ff0cf63e2be7e584c2e91767724420e79c3922ab65';
return jwt_str;
}

if(!!localStorage.getItem(this.$access_token_key)){
jwt_str = localStorage.getItem(this.$access_token_key);
}
return jwt_str;
}

Vue.prototype.is_login = function(){

if(this.$is_test){
return true;
}

console.log('check_is_login');
let login_data = this.get_login_session_data();
console.log('login_data_length:'+login_data.length);
let is_login = false;
if(!!login_data.member_id && login_data.member_id > 0){
is_login = true;
}
return is_login;


}

/*
验证成功后要跳转的页面，但是必须过滤一些页面
*/
Vue.prototype.login_member_go_url = function(){
console.log('check is_login');
let route_path = this.$route.path;
let login_data = this.get_login_session_data();
let wx_auth_url = '/WxLoginState';
let bind_acc_url =  '/Login';

if(login_data && !!login_data.openid){
if(!login_data.YZICode && route_path != bind_acc_url){


this.$router.push({path: bind_acc_url});
}
}else if(route_path != wx_auth_url){


this.get_wx_code();
}

}
Vue.prototype.check_is_phone = function(phone){
console.log('phone'+phone)
let myreg = /^1[1-9]{1}\d{9}$/;
let is_phone = true;
if(!myreg.test(phone)){
is_phone = false;
}
return is_phone;
}

Vue.prototype.baseShowModule = function(title,content = '温馨提示',go_url = '',is_refresh = false) {
var _this = this;
AlertModule.show({
title: title,
content: content,
onShow () {
console.log('Module: I\'m showing')
},
onHide () {
console.log('Module: I\'m hiding now--');
if(!!go_url){

if(is_refresh){
location.reload();
}else{
_this.$router.push({path: go_url});
}
}
}
})
},
Vue.prototype.baseShowModuleAuto  = function(title,content = '温馨提示',show_all_time = 3000,go_url = '',is_refresh = false) {
this.baseShowModule(title,content,go_url)
setTimeout(() => {
AlertModule.hide()
}, show_all_time)
}

Vue.prototype.check_token_data_status = function(data){


if(!this.$is_test){
if(data.status == '-10'){
this.baseShowModuleAuto('非法操作');
setTimeout(() => {
this.clear_login_session_data();
window.opener=null;
window.open('','_self');
window.close();
WeixinJSBridge.call('closeWindow');
}, 2000)
return;
}else if(data.status == '-11'){
this.clear_login_session_data();
this.baseShowModuleAuto('登陆已过期，即将重新登陆','温馨提示',2000,'/',true);
return;
}
else if(data.status == '-12'){
this.clear_login_session_data();
this.baseShowModuleAuto('系统已升级，请重新登陆','温馨提示',2000,'/',true);
return;
}
}
}
/*export default{
test_api: function(){
this.$axios({
method:'post',
url:host_url+'api',
data:this.qs.stringify({    //这里是发送给后台的数据
userId:this.userId,
token:this.token,
})
}).then((response) =>{          //这里使用了ES6的语法
console.log(response)       
}).catch((response) =>{
console.log(response)       
})
}
}*/




// WEBPACK FOOTER //
// ./src/utils/api.js